import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import "./styles/fonts.css";
import favicon from "./static/img/Favicon.png";

// set favicon dynamically (uses bundler to resolve the image path)
const setFavicon = (href) => {
  try {
    let link = document.querySelector("link[rel*='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = href;
  } catch (e) {
    // ignore in non-browser environments
    // console.warn('Could not set favicon', e);
  }
};

setFavicon(favicon);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
